define([
	"dojo/_base/declare",
	"csi",
	"csi/form/Widget",
	"csi/table/NewFrom",
	"csi/xml",
	"Quality/TestRunActionMixin"
], function(declare, csi, Widget, NewFrom, xml, TestRunActionMixin) {

	return declare([ NewFrom, TestRunActionMixin ], {
		/**
		 * @override
		 * Disable Save & Go since this form allows multiple TestRun creation
		 */
		_canNavigate: function() {
			return false;
		},

		getFormData: function() {
			// summary: when copying test run make sure to blank out color and sample fields so they don't
			// get referenced by another product. We could probably do better here by checking if the source
			// and target test runs are within the same product, but this will do for now.
			var fd = this.inherited(arguments);
			fd.setFieldInitialValue("TestRunColor", csi.EMPTY_URL);
			fd.setFieldInitialValue("DimensionColors", csi.EMPTY_URL);
			fd.setFieldInitialValue("TestRunSample", csi.EMPTY_URL);
			return fd;
		},

		_getFormView: function(/*Node*/node, /*Boolean*/bCheckOnly) {
			// summary: hide Test Group field
			var defView = this.inherited(arguments);
			if (defView && typeof defView === "object") {
				this._hideFields(defView, this.m_cache);
			}
			return defView;
		},

		/**
		 * @override
		 * Retrieves the params for the current view - by default, gets the parent of the current object,
		* sets current color material if there is one and sets flag to create multiple test runs
		*/
		onCreatePopupParams: function(params) {
			params = params || {};
			params.testRunContextNode = this.getParent();
			params.bCanCreateMultipleTestRuns = true;
		},

		/**
		 * @override
		 * set fixed field values based on context
		 */
		onCreatePopup: function(view) {
			this._disableColorOrSample(view);
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Retrieve the new Test Run nodes
		 */
		getNewNodes: function() {
			if (this.popupView.bCanCreateMultipleTestRuns) {
				return this.m_cache.getNodes(this.popupView.newTestRuns);
			}

			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Retrieve return node request
		 */
		getReturnNodeRequest: function(urlsNew) {
			if (this.popupView.bCanCreateMultipleTestRuns
                    && this.popupView.newTestRuns) {
                urlsNew = urlsNew.concat(this.popupView.newTestRuns);
            }
            return this.inherited(arguments, [ urlsNew ]);
        },

		/**
		 * @override
		 * Change NewFrom handling to deal with multi-TestRun creation
		 */
		_processSource: function(node) {
			if (this.popupView.bCanCreateMultipleTestRuns) {
				this.m_nodeSource = node;
				this.popupView.toWriterTestRuns(this);
			} else {
				this.inherited(arguments);
			}
		},

		/**
		 * @override
		 * Normally, MoveFromController adds From parameter, so need
		 * to add it through another call that will be called for each
		 * new Test Run
		 */
		_writeRequestParameters: function(call) {
			this.inherited(arguments);
			call.addParameter(xml.PROP_URL_FROM, xml.ATTR_REF, xml.nodeGetURL(this.m_nodeSource));
		}
	});
});